import Link from "next/link";

const Benefits = ({ title, subtitle, items = [] }) => {
  return (
    <section className="bg-background py-20 px-4 text-text">
      <div className="max-w-[1140px] mx-auto">
        {/* Heading */}
        <div className="text-left mb-12">
          <h2 className="text-4xl tracking-[6px] uppercase text-primary font-light mb-4">
            {title}
          </h2>
          <p className="text-xl font-light text-darkBackground font-gilda">
            {subtitle}
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((item, index) => {
            const CardContent = (
              <>
                <div className="mb-4">{item.icon}</div>
                <h3 className="text-xl font-light text-black mb-2 font-gilda">
                  {item.title}
                </h3>
                {item.description && (
                  <p className="text-sm text-gray font-light">
                    {item.description}
                  </p>
                )}
              </>
            );

            // If item has href, wrap with Link
            if (item.href) {
              return (
                <Link
                  key={index}
                  href={item.href}
                  className="block bg-white border border-[#f1eeeb] px-6 py-8 text-center min-h-[180px]"
                >
                  {CardContent}
                </Link>
              );
            }

            // Otherwise render as static card
            return (
              <div
                key={index}
                className="bg-white border border-[#f1eeeb] px-6 py-8 text-center min-h-[180px]"
              >
                {CardContent}
              </div>
            );
          })}
        </div>

        <div className="mt-8 text-center">
          <a
            href="#quote-form"
            className="inline-block text-lg uppercase py-3 px-8 bg-primary text-white font-base hover:bg-black transition-all duration-500 ease-in-out"
          >
            Request Free Estimate
          </a>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
